module.exports = __webpack_public_path__ + "static/media/People.ff555665.svg";